export const msalConfig = {
  auth: {
    clientId: 'a68d48c1-91ba-4824-9575-c199798fcd21', // This is the ONLY mandatory field that you need to supply.
    authority: 'https://klaitonciam.b2clogin.com/klaitonciam.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN', // Choose SUSI as your default authority.
    // authority: 'https://klaitonciam.b2clogin.com/klaitonciam.onmicrosoft.com/B2C_1A_SIGNIN_WITH_MAGIC_LINK', // Choose SUSI as your default authority.
    knownAuthorities: ['klaitonciam.b2clogin.com'], // Mark your B2C tenant's domain as trusted.
    // redirectUri: 'https://hke.lamberti.at/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    // postLogoutRedirectUri: 'https://hke.lamberti.at/', // Indicates the page to navigate after logout.
    redirectUri: 'https://klaitonciam.lamberti.at/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: 'https://klaitonciam.lamberti.at/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If 'true', will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to 'true' if you are having issues on IE11 or Edge
  }
}
